// import {gsap} from 'gsap'

export default class ClickSlider {
  constructor(slider = null) {
    this.slider = slider
    this.images = this.slider.querySelectorAll('.image-item')
    this.parent = this.slider.querySelector('.slider-content')
    this.arrowRight = this.slider.querySelector('.arrow-right')
    this.counter = this.slider.querySelector('.counter .current')
    this.isWorking = false
    this.firstActive = 200
    this.animationDuration = 1
    this.verticalOffset = 40

    this.init()
    this.events()
    window.dispatchEvent(new Event('resize'))
  }

  init() {
    this.images.forEach(i => {
      if ( i.classList.contains('active') ) {
		  gsap.set(i, {left: 0, top: 0, y: `-${this.verticalOffset}px`, scale: 1})
		  this.firstActive = i
      } else if ( i.classList.contains('next') ) {
		  gsap.set(i, {right: 0, y: `${this.verticalOffset}px`, scale: '0.8'})
      } else {
		  gsap.set(i, {right: 0, y: `${this.verticalOffset}px`, scale: '0.8', rotate: '-10deg', x: '10%'})
	  }
    })
  }

  onSliderClick = ev => {
    if (this.isWorking) return

    this.isWorking = true

    const currentImage = Array.from(this.images).find( e => e.classList.contains('active'));
    const nextImage    = Array.from(this.images).find( e => e.classList.contains('next'));
    const nextNextImage    = Array.from(this.images).find( e => e.classList.contains('next-next'));

    const currentIndex  = Array.from(this.parent.children).indexOf(currentImage);
	const nextIndex = Array.from(this.parent.children).indexOf(nextImage);
	const nextNextIndex = Array.from(this.parent.children).indexOf(nextNextImage);

	const f_currentIndex = (currentIndex + 1)%3;
	const f_nextIndex = (f_currentIndex + 1)%3;
	const f_nextNextIndex = (f_nextIndex + 1)%3;

    this.parent.children[f_nextIndex].classList.add('next');
    this.parent.children[f_nextNextIndex].classList.add('next-next');

    gsap.to(currentImage, {
      duration: this.animationDuration,
      opacity: 0,
      x: -250,
      y: -250,
      rotate: '4deg',
      ease: 'power2.out',
      onComplete: () => {
        currentImage.classList.remove('active')
		  currentImage.classList.add('next-next')

		  currentImage.style.left = null
		  currentImage.style.transform = null
		  gsap.set(currentImage, {right: 0, y: `${this.verticalOffset}px`, scale: '0.8', rotate: '-10deg', x: '10%', opacity: 1})
	  }
    })

	  nextImage.classList.remove('next')
	  nextImage.classList.add('intermediate')

	  gsap.to(nextImage, {
		  duration: this.animationDuration,
		  scale: 1,
		  y: `-${this.verticalOffset}px`,
		  left: 0,
		  ease: 'power2.inOut',
		  onComplete: () => {
			  nextImage.classList.remove('intermediate')
			  nextImage.classList.add('active')
		  }
	  })

	  nextNextImage.classList.remove('next-next')
	  nextNextImage.classList.add('next')

	  gsap.to(nextNextImage, {
		  duration: this.animationDuration,
		  scale: 0.8,
		  rotate: 0,
		  x: 0,
		  y: `${this.verticalOffset}px`,
		  ease: 'power2.inOut',
		  onComplete: () => {
			  nextNextImage.style.left = null
			  this.isWorking = false
		  }
	  })
  }

  setSliderHeight() {
    this.slider.style.height = `${this.firstActive.offsetHeight}px`
  }

  onWindowResize(ev) {
    this.setSliderHeight.bind(this)
  }

  events() {
    this.slider.addEventListener('click', this.onSliderClick.bind(this), false)

    window.addEventListener('resize', ev => {
      if (this.scrollTimeout) {
        window.clearTimeout(this.scrollTimeout)
      }

      this.scrollTimeout = window.setTimeout(() => {
        this.setSliderHeight.bind(this)()
      }, 250)
    })

  }
}
